module.exports = __webpack_public_path__ + "static/media/onyka_barrett_scott.047fdf48.pdf";